import {
  NumberField as DSNumberField,
  NumberProps,
  NumberFieldG4PProps,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";
import { forwardRef } from "react";

export const NumberField = forwardRef(
  (props: NumberProps | NumberFieldG4PProps, ref) => {
    const formatMessage = useFormatMessage();
    return (
      <DSNumberField
        ref={ref}
        key={props.name}
        descriptionAriaLabel={formatMessage(
          "generic.tooltip.infoIcon.ariaLabel"
        )}
        tooltipCloseIconAriaLabel={formatMessage(
          "generic.tooltip.closeIcon.ariaLabel"
        )}
        {...props}
      />
    );
  }
);
